<script>
export default {
  computed: {},
  methods: {},
  created() {
    this.$store.dispatch('session/logout')
    this.$router.push({ path: '/login' }).catch(() => {})
  },
}
</script>

<style scoped></style>
